<template>
  <v-autocomplete
    class="search-bak"
    :items="activeBranches"
    @input="input"
    :label="label"
    hide-no-data
    item-text="branchName"
    item-value="id"
    outlined
    placeholder="Start typing to search branches"
    ref="autocomplete"
    cache-items
    v-on="$listeners"
    v-bind="$attrs"
  />
</template>
<script>
import CoreMixin from '@/mixins/core.mixin';
import { mapGetters } from 'vuex';
export default {
  name: 'BranchPicker',

  mixins: [CoreMixin],

  props: {
    active: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: 'Branch'
    }
  },

  computed: {
    ...mapGetters('branchModule', ['branches']),

    activeBranches() {
      return this.branches.filter((branch) => branch.isActive);
    }
  },

  methods: {
    input(event) {
      this.$emit('input', event);
    }
  }
};
</script>
